import script from "./ChatMySharesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatMySharesModal.vue?vue&type=script&setup=true&lang=js"

import "./ChatMySharesModal.vue?vue&type=style&index=0&id=90133fd2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90133fd2"]])

export default __exports__